import React from 'react';

import FilterChips from '../common/FilterChips';

/**
 * The shared FilterChips under the items page's name. The items page passes
 * its own `className` ("items-page__filter-chips"); every other consumer gets
 * the shared default. Kept so existing imports and tests stay untouched.
 */
export default function ItemFilterChips(props) {
	return <FilterChips {...props} />;
}
